const DATA_TEST_IDS = {
  usersList: 'module__users-list',
} as const;

export default DATA_TEST_IDS;
